import React from 'react';

import Pagination from '../components/Pagination';
import Layout from '../components/Layout';
import NewsItem from '../views/News';
import PageTitle from '../components/PageTitle';

import SimpleHelmet from '../components/SimpleHelmet';

export const NewsTemplate = ({
  pageInfo,
  news,
  title,
  seoDescription,
  seoUrl
}) => {
  return (
    <Layout>
      <PageTitle
        title={`${title}${
          pageInfo.currentPage != 1 ? ` - page ${pageInfo.currentPage}` : ``
        }`}
      />
      <SimpleHelmet
        seoTitle={title}
        seoDescription={seoDescription}
        seoUrl={seoUrl}
      />
      {news.map(
        ({ heading, subheading, content, image, day, month, year }, index) => (
          <NewsItem
            heading={heading}
            subheading={subheading}
            content={content}
            image={image}
            day={day}
            month={month}
            year={year}
            key={heading}
            light={index % 2 == 1}
          />
        )
      )}
      <Pagination
        hasPreviousPage={pageInfo.hasPreviousPage}
        hasNextPage={pageInfo.hasNextPage}
        currentPage={pageInfo.currentPage}
        rootPath="/news"
        light={news.length % 2 === 0}
      />
    </Layout>
  );
};

const News = ({ data }) => {
  const { edges, pageInfo } = data.allMarkdownRemark;

  const news = edges.map(({ node, html }) => {
    const { heading, subheading, image, day, month, year } = node.frontmatter;
    return {
      content: node.html,
      heading,
      subheading,
      image,
      day,
      month,
      year
    };
  });

  const { title, seoDescription } = data.metadata.frontmatter;
  const seoUrl = data.metadata.fields.slug;

  return (
    <NewsTemplate
      pageInfo={pageInfo}
      news={news}
      title={title}
      seoDescription={seoDescription}
      seoUrl={seoUrl}
    />
  );
};

export default News;

export const pageQuery = graphql`
  query NewsTemplate($skip: Int!, $limit: Int!) {
    metadata: markdownRemark(frontmatter: { type: { eq: "news-vars" } }) {
      frontmatter {
        title
        seoDescription
      }
      fields {
        slug
      }
    }
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/news/.*\\\\.md$/" } }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          frontmatter {
            heading
            subheading
            image {
              childImageSharp {
                fluid(maxWidth: 500) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            day: date(formatString: "DD")
            month: date(formatString: "MMM")
            year: date(formatString: "YY")
          }
          html
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        currentPage
      }
    }
  }
`;
